import { render, staticRenderFns } from "./IntegrationLgConfigCodesForm.vue?vue&type=template&id=365f6131"
import script from "./IntegrationLgConfigCodesForm.vue?vue&type=script&lang=js"
export * from "./IntegrationLgConfigCodesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports